<div class="flyout-sessions-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <img class="header-icon" src="/assets/img/icons_fl/analytics.svg" width="20px" height="20px" />
        <span>{{ "flyout.sessions.title" | translate }}</span>
      </mat-expansion-panel-header>

      @if (!isMobile) {
        <div>
          <div class="expansion-panel-row header">
            <div class="column time">
              <span>{{ "flyout.time" | translate }}</span>
            </div>
            <div class="column duration">
              <span>{{ "flyout.duration" | translate }}</span>
            </div>
            <div class="column star-engagement header">
              <span>{{ "flyout.engagement" | translate }}</span>
            </div>
            <div class="column source">
              <span>{{ "flyout.visit-source" | translate }}</span>
            </div>
            <div class="column views">
              <span>{{ "flyout.views" | translate }}</span>
            </div>
          </div>
          @for (visit of visitsToShow; track visit) {
            <div class="expansion-panel-row values" (click)="openFlyoutForSession(visit.sessionId, flyoutOpeningData.identifier, visit.engagement)">
              <div class="column time">
                <span>{{ visit.formattedTimestamp }}</span>
              </div>
              <div class="column duration">
                @if (visit.timeOnSite) {
                  <div class="duration-indicator" [style.width.%]="visit.timeOnSite >= 90 ? 100 : (visit.timeOnSite / 90) * 100"></div>
                }
                <!--<div class="duration-text">{{action.actionType}}</div>-->
                @if (visit.timeOnSite) {
                  <div class="duration-text">{{ visit.timeOnSite | prettySeconds }}</div>
                }
              </div>
              @if (visit.engagement) {
                <div class="column star-engagement">
                  @for (item of [].constructor(7); track $index; let i = $index) {
                    @if (i < visit.engagement) {
                      <mat-icon>star</mat-icon>
                    }
                    @if (i >= visit.engagement) {
                      <mat-icon>star_border</mat-icon>
                    }
                  }
                </div>
              }
              <div class="column source">
                <span>{{ visit.source }}</span>
              </div>
              <div class="column views">
                @if (visit.views > 0) {
                  <span>{{ visit.views }}</span>
                }
                @if (visit.views === 0) {
                  <span>N/A</span>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (isMobile) {
        <div>
          @for (visit of visitsToShow; track visit) {
            <div class="expansion-panel-row values" (click)="openFlyoutForSession(visit.sessionId, flyoutOpeningData.identifier, visit.engagement)">
              <div class="column mobile-left">
                @if (visit.engagement) {
                  <div class="star-engagement row">
                    @for (item of [].constructor(7); track $index; let i = $index) {
                      @if (i < visit.engagement) {
                        <mat-icon>star</mat-icon>
                      }
                      @if (i >= visit.engagement) {
                        <mat-icon>star_border</mat-icon>
                      }
                    }
                  </div>
                }
                <span class="row">{{ visit.formattedTimestamp }}</span>
                <span class="row">
                  <span class="bold">{{ "flyout.visit-source" | translate }}</span>
                  : {{ visit.source }}
                </span>
              </div>
              <div class="column mobile-right">
                <div class="duration row">
                  @if (visit.timeOnSite) {
                    <div class="duration-indicator" [style.width.%]="visit.timeOnSite >= 90 ? 100 : (visit.timeOnSite / 90) * 100"></div>
                  }
                  <!--<div class="duration-text">{{action.actionType}}</div>-->
                  @if (visit.timeOnSite) {
                    <div class="duration-text">{{ visit.timeOnSite | prettySeconds }}</div>
                  }
                </div>
                <span class="row">
                  <span class="bold">{{ "flyout.views" | translate }}</span>
                  :
                  @if (visit.views > 0) {
                    <span>{{ visit.views }}</span>
                  }
                  @if (visit.views === 0) {
                    <span>N/A</span>
                  }
                </span>
              </div>
            </div>
          }
        </div>
      }
      @if (visits.length > 5) {
        <div class="expansion-panel-row pagination">
          <div class="navigation" (click)="navigateVisits(false)">
            <span>
              <mat-icon>arrow_back</mat-icon>
              {{ "generic.previous" | translate }}
            </span>
          </div>
          <span>{{ spanStart }} - {{ spanEnd }} {{ "generic.of" | translate }} {{ visits.length }}</span>
          <div class="navigation" (click)="navigateVisits(true)">
            <span>
              {{ "generic.next" | translate }}
              <mat-icon>arrow_forward</mat-icon>
            </span>
          </div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
